import { getClassLevel } from './classIdentity.mjs';
import { CLASS_CASTING_PROFILES } from './classSpellcasting.mjs';
import slotTables from './spellSlotTables.js';

export const SPELL_SLOT_LEVELS = Object.freeze([1, 2, 3, 4, 5, 6, 7, 8, 9]);

export const { SPELLCASTING_SLOTS, PACT_MAGIC_SLOTS } = slotTables;

export const getEffectiveCasterLevel = (character) => Object.values(CLASS_CASTING_PROFILES)
  .reduce((total, profile) => {
    const level = getClassLevel(character, profile.id);
    if (profile.casterProgression === 'full') return total + level;
    if (profile.casterProgression === 'half') return total + Math.ceil(level / 2);
    return total;
  }, 0);

const nonnegativeInteger = (value) => Math.max(0, Math.floor(Number(value) || 0));

export const getSpellSlotProfile = (character = {}) => {
  const casterLevel = Math.min(20, getEffectiveCasterLevel(character));
  const maxima = SPELLCASTING_SLOTS[casterLevel] || {};
  const rawSpent = character?.spellcastingState?.spellcasting?.spentByLevel || {};
  const maximumByLevel = {}; const spentByLevel = {}; const effectiveSpentByLevel = {}; const remainingByLevel = {};
  SPELL_SLOT_LEVELS.forEach((level) => {
    const maximum = nonnegativeInteger(maxima[level]);
    const spent = nonnegativeInteger(rawSpent[String(level)]);
    maximumByLevel[String(level)] = maximum;
    spentByLevel[String(level)] = spent;
    effectiveSpentByLevel[String(level)] = Math.min(maximum, spent);
    remainingByLevel[String(level)] = maximum - effectiveSpentByLevel[String(level)];
  });
  const warlockLevel = Math.min(20, nonnegativeInteger(getClassLevel(character, 'warlock')));
  const pact = PACT_MAGIC_SLOTS[warlockLevel] || PACT_MAGIC_SLOTS[0];
  const pactSpent = nonnegativeInteger(character?.spellcastingState?.pactMagic?.spent);
  const effectivePactSpent = Math.min(pact.maximum, pactSpent);
  return {
    spellcasting: { casterLevel, maximumByLevel, spentByLevel, effectiveSpentByLevel, remainingByLevel },
    pactMagic: { warlockLevel, slotLevel: pact.slotLevel, maximum: pact.maximum, spent: pactSpent,
      effectiveSpent: effectivePactSpent, remaining: pact.maximum - effectivePactSpent },
  };
};

export const noSpellSlotCost = () => Object.freeze({ type: 'none' });
